export default __webpack_public_path__ + "static/media/spinner.a1a99674.gif";